<template>
  <div></div>
</template>
<script>
export default {
  props: ["showPrompt", "item", "callback"],

  watch: {
    showPrompt(newPrompt) {
      if (newPrompt) {
        this.open();
      }
    },
  },
  methods: {
    open() {
      this.$confirm(
        `This will permanently delete ${this.item} from the list. Continue?`,
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.callback(true);
        })
        .catch(() => {
          this.callback(false);
        });
    },
  },
};
</script>
